import chroma from "chroma-js";
const LUMINANCE_RATIO = 0.46;
const readableColor = (lightTextColor, darkTextColor) => (hex) => {
  if (hex === "transparent") {
    return hex;
  }
  return chroma(hex).luminance() < LUMINANCE_RATIO ? lightTextColor : darkTextColor;
};
export default readableColor;
